module.exports = __webpack_public_path__ + "static/media/gusset-box.82bd5dbd.ai";